import React from 'react';
import type { MLinkAddressProps, MLinkAddressItem } from './MLinkAddress.types';
import * as Styled from './MLinkAddress.styles';
import { ABody, ABodySize } from '../../atoms/ABody/index';
import { AIcon } from '../../atoms/AIcon/index';
import { AIconSize } from '../../atoms/AIcon/AIcon.types';

export function MLinkAddress(props: MLinkAddressProps): JSX.Element {
  const { mListNav = [], dataTestId, className } = props;

  return (
    <Styled.Wrapper data-testid={dataTestId} className={className}>
      {mListNav.map((item: MLinkAddressItem, index: number) => (
        <Styled.ItemContainer key={index} className="mb-2">
          <div className="d-flex flex-column">
            {item.aIcon && (
              <div className="mb-1">
                <AIcon icon={item.aIcon.icon} size={item.aIcon.size || AIconSize.S} />
              </div>
            )}
            <ABody bodyText={item.lineOne} size={ABodySize.M} />
            <ABody bodyText={item.lineTwo} size={ABodySize.M} />
          </div>
          {item.arrow && (
            <div className="mt-2">
              <AIcon icon="icon-forward-arrow" size={AIconSize.S} />
            </div>
          )}
        </Styled.ItemContainer>
      ))}
    </Styled.Wrapper>
  );
}
